// src/components/Footer.jsx
import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp, FaLinkedin, FaFacebook, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { useLang } from '../context/LangContext';
import { FOOTER } from '../data/content';

const SOCIAL_LINKS = [
  { icon: <FaWhatsapp />, url: 'https://wa.me/201009994500',                        hoverColor: '#25D366', label: 'WhatsApp' },
  { icon: <FaLinkedin />, url: 'https://www.linkedin.com/company/lawaseq-egypt/',   hoverColor: '#0077b5', label: 'LinkedIn' },
  { icon: <FaFacebook />, url: 'https://www.facebook.com/LawaseqEgyptIndustries/', hoverColor: '#1877F2', label: 'Facebook' },
];

const Footer = () => {
  const { currentLang, isRtl } = useLang();
  const t = FOOTER[currentLang];

  const quickLinks = useMemo(() => [
    { label: t.links.home,      href: '#hero'      },
    { label: t.links.about,     href: '#about'     },
    { label: t.links.services,  href: '#services'  },
    { label: t.links.portfolio, href: '#portfolio' },
    { label: t.links.contact,   href: '#contact'   },
  ], [t.links]);

  return (
    <footer className="lsq-footer" dir={isRtl ? 'rtl' : 'ltr'}>
      <div className="lsq-footer-grid">

        <div className="lsq-footer-col">
          <img
            src="/assets/images/lawaseq-logo.png"
            alt="Lawaseq Logo"
            className="lsq-footer-logo"
            width="160"
            height="55"
            loading="lazy"
          />
          <p className="lsq-footer-about">{t.about}</p>

          <div className="lsq-footer-socials">
            {SOCIAL_LINKS.map(({ icon, url, hoverColor, label }) => (
              <motion.a
                key={label}
                href={url}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                whileHover={{ y: -5 }}
                whileTap={{ scale: 0.9 }}
                className="lsq-social-btn"
                style={{ '--hover-color': hoverColor }}
              >
                {icon}
              </motion.a>
            ))}
          </div>
        </div>

        <div className="lsq-footer-col">
          <h4 className="lsq-footer-heading">
            {t.quickLinks}
            <span className="lsq-footer-heading-line" />
          </h4>
          <ul className="lsq-footer-nav">
            {quickLinks.map(({ href, label }) => (
              <li key={href}>
                <a href={href} className="lsq-footer-nav-link">
                  <span aria-hidden>{isRtl ? '←' : '→'}</span>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lsq-footer-col">
          <h4 className="lsq-footer-heading">
            {t.contactUs}
            <span className="lsq-footer-heading-line" />
          </h4>
          <div className="lsq-footer-contacts">
            <div className="lsq-contact-row">
              <FaMapMarkerAlt className="lsq-contact-icon" aria-hidden />
              <span>{t.address}</span>
            </div>
            <a href="tel:+201009994500" className="lsq-contact-row">
              <FaPhone className="lsq-contact-icon" aria-hidden />
              <span dir="ltr">+20 10 099 94500</span>
            </a>
            <a href="tel:+201228277068" className="lsq-contact-row">
              <FaPhone className="lsq-contact-icon" aria-hidden />
              <span dir="ltr">+20 12 282 77068</span>
            </a>
            <a href="mailto:info@lawaseq.com.eg" className="lsq-contact-row">
              <FaEnvelope className="lsq-contact-icon" aria-hidden />
              <span>Mohamed.sobhi@lwsqeg.com</span>
            </a>
          </div>
        </div>
      </div>

      <div className="lsq-copyright-bar">
        <p>
          {t.copyright}
          <span className="lsq-gold-text">LAWASEQ INDUSTRIES</span>
        </p>
      </div>
    </footer>
  );
};

export default Footer;